import React from 'react';

import styled from 'styled-components';

import useLogo from '@hooks/Layout/UseLogo';

const StyledImage = styled.img`
    max-height: 80px;
    max-width: 200px;
    width: auto;
    height: auto;
`;

const CompanyLogo = () => {
    const logoUrl = useLogo();

    return <StyledImage src={logoUrl} alt="company logo" />;
};

export default CompanyLogo;
